module.exports = "/assets/data/46d3c096723f31ecabfdcae33798e9d9-SW1V.data.json";